/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetRenewalEligibleResponse = {
  renewalType: GetRenewalEligibleResponse.renewalType;
  licenseType: GetRenewalEligibleResponse.licenseType;
  link: string;
  is70s: boolean;
  is7yearsAccidentFree: boolean;
};
export namespace GetRenewalEligibleResponse {
  export enum renewalType {
    CLASS1_RENEWAL = 'CLASS1_RENEWAL',
    CLASS2_RENEWAL = 'CLASS2_RENEWAL',
    OVER_70YEARS_RENEWAL = 'OVER_70YEARS_RENEWAL',
    ACCIDENT_FREE_OVER_7YEARS = 'ACCIDENT_FREE_OVER_7YEARS',
    ACCIDENT_FREE_OVER_7YEARS_RENEWAL = 'ACCIDENT_FREE_OVER_7YEARS_RENEWAL',
    NOT_SUBJECT = 'NOT_SUBJECT',
    FAIL_CUSTOMER_INFO = 'FAIL_CUSTOMER_INFO',
    FAIL_SYSTEM_ERROR = 'FAIL_SYSTEM_ERROR',
    FAIL_POLICE_CASE = 'FAIL_POLICE_CASE',
    FAIL_OVER_75YEARS = 'FAIL_OVER_75YEARS',
  }
  export enum licenseType {
    CLASS_1_LICENSE = 'CLASS_1_LICENSE',
    CLASS_2_LICENSE = 'CLASS_2_LICENSE',
  }
}

